import { Button } from "@/components/ui/button";
import { ShieldX, LogOut } from "lucide-react";
import { useAuth } from "@/hooks/use-auth";
import { ADMIN_STYLES } from "@/lib/admin-styles";

export function AdminAccessDenied() {
  const { logoutMutation } = useAuth();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <div className="max-w-md text-center">
        <ShieldX className="h-12 w-12 text-destructive mx-auto mb-4" />
        <h1 className={ADMIN_STYLES.header.title}>Access denied</h1>
        <p className={`${ADMIN_STYLES.header.subtitle} mt-2 mb-6`}>
          Your account does not have admin permissions. Contact the site owner if you believe this is an error.
        </p>
        <div className="flex flex-col sm:flex-row gap-2 justify-center">
          <Button variant="outline" asChild>
            <a href="/">Go to site</a>
          </Button>
          <Button
            variant="bronze"
            onClick={() => logoutMutation.mutate()}
            disabled={logoutMutation.isPending}
          >
            <LogOut className="h-4 w-4 mr-2" />
            Log out
          </Button>
        </div>
      </div>
    </div>
  );
}
